import clsx from "clsx";
import FormFieldErrors from "../../Reusable/FormFieldErrors";
import { useFormUtils } from "@/app/hooks/useFormUtils";
import { IInput } from "../../interface";

const NumberInput: React.FC<IInput> = ({
  fieldError,
  variant = "SOLID",
  errorMessages,
  disableFieldError,
  className,
  register,
  ...props
}) => {
  const { deduceFormFieldErrors, isFormFieldValid } = useFormUtils();

  const reducedErrorMessages = deduceFormFieldErrors(errorMessages, fieldError);
  const isValid = isFormFieldValid(reducedErrorMessages);

  return (
    <div className={clsx("relative", className)}>
      <div
        className={clsx(
          "relative flex justify-start items-center w-full",
          variant === "SOLID" ? " shadow-sm rounded-md" : "",
        )}
      >
        {props?.startIcon && (
          <div className="left-0 inset-y-0 flex justify-center items-center pr-2 pl-2 pointer-events-none">
            {props?.startIcon}
          </div>
        )}
        <input
          {...register}
          {...props}
          type="text" // Use "text" to allow leading zeros
          autoComplete="off"
          autoCorrect="off"
          autoFocus={true}
          inputMode="numeric" // Ensures a numeric keyboard on mobile
          className={clsx(
            variant === "SOLID"
              ? `border-0 py-1.5 ring-1 ring-inset font-medium text-xs focus:ring-1 focus:ring-inset disabled:bg-gray-200 disabled:text-gray-600 sm:leading-6 w-full ${props?.inputClassName}`
              : `border-none outline-none font-medium bg-transparent ring-0 shadow-none focus:border-none focus-within:border-none focus-within:outline-none focus:outline-none focus:ring-0 text-xs py-1.5 w-full ${props?.inputClassName}`,
            isValid
              ? `text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-indigo-600 w-full font-medium`
              : `text-red-900 ring-red-300 placeholder:text-red-400 focus:ring-red-600`,
            props?.startIcon ? "rounded-r-md" : props?.endIcon ? "rounded-l-md" : "rounded-md",
          )}
          onInput={(e) => {
            let value = e.currentTarget.value;
            // Allow only numbers and a single dot
            value = value.replace(/[^0-9.]/g, '');

            // Only allow one dot
            const parts = value?.split('.');
            if (parts.length > 2) {
              value = parts[0] + '.' + parts[1];
            }

            // Limit to 1 digit after decimal
            if (parts[1]?.length > 2) {
              value = parts[0] + '.' + parts[1].slice(0, 2);
            }

            e.currentTarget.value = value;
          }}
        />
        {props?.endIcon && (
          <div className="right-0 inset-y-0 flex justify-center items-center pr-2 pl-2 text-xs pointer-events-none">
            {props?.endIcon}
          </div>
        )}
      </div>
      <div className="left-1 absolute w-72 overflow-visible">
        <FormFieldErrors errors={reducedErrorMessages} />
      </div>
    </div>
  );
};

export default NumberInput;
